module.exports = __webpack_public_path__ + "static/media/bazterrica-login.4b8c9322.svg";